export default {"src":"/_next/static/media/merger.85a180e1.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};